// Entry point for ES6+ modules

import common from './common.js';
import { _ua, _breakP, _log } from './utils.js';
import LenisController from './lenis-controller.js';
import HeaderController from './header-controller.js';
import TopPage from '../../../js/_function.js';
import accessPage from '../../../access/js/_function.js';
import commonspacePage from '../../../commonspace/js/_function.js';
import locationPage from '../../../location/js/_function.js';
import slider from './slider.js';
import Accordion from './accordion.js';
import Parallax from './parallax.js';
import Tab from './tab.js';
import HorizontalScroll from './horizontal-scroll.js';
import StackingItems from './stacking-items.js';
import Movie from './movie.js';
import PageTop from './pagetop.js';
import SwipeFigure from './swipefigure.js';
import ZoomFigure from './zoomfigure.js';
import MoreBtn from './morebtn.js';
import Modal from './modal.js';
import FloatingBanner from './floating-banner.js';
import LocalNav from './local-nav.js';
function initApp() {
  new common();
  new LenisController();
  new HeaderController();
  new slider();
  new Accordion();
  new Parallax();
  new HorizontalScroll();
  new StackingItems();
  new Movie();
  new PageTop();
  new ZoomFigure();
  new MoreBtn();
  new SwipeFigure();
  new Tab();
  new Modal();
  new FloatingBanner();
  new LocalNav();
  try {
    const isTopPage = Boolean(document.querySelector('.currentPage--top'));
    const isAccessPage = Boolean(document.querySelector('.currentPage--access'));
    const isCommonspacePage = Boolean(document.querySelector('.currentPage--commonspace'));
    const isLocationPage = Boolean(document.querySelector('.currentPage--location'));

    if (isTopPage) {
      new TopPage();
    }

    if (isAccessPage) {
      new accessPage();
    }

    if (isCommonspacePage) {
      new commonspacePage();
    }

    if (isLocationPage) {
      new locationPage();
    }

  } catch (error) {
    console.error('[App] Failed to initialise page modules', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp, { once: true });
} else {
  initApp();
}

// Export for potential use in other modules
export { common, _ua, _breakP, _log };
